var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4E86751F-D7F5-4F0E-AA7A-7B0787A23F0E@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kitlfy-for-Business-Style-Guide_2",
    transform: "translate(-788.000000, -503.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit",
    transform: "translate(789.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-edit",
    transform: "translate(0.375000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "11.7717391 0 14.25 2.34782609 6.31956522 9.86086957 2.85 10.8 3.84130435 7.51304348"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.975,
    y1: 2.025,
    x2: 12.1125,
    y2: 4.05,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.825,7.89230769 L12.825,12.5653846 C12.825,13.0812923 12.3830308,13.5 11.8384615,13.5 L0.986538462,13.5 C0.441969231,13.5 0,13.0812923 0,12.5653846 L0,2.28461538 C0,1.76870769 0.441969231,1.35 0.986538462,1.35 L5.91923077,1.35",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9d36d06b7a33821f6480f9cb6d2e5637.svg";
export { ForwardRef as ReactComponent };